import { render, staticRenderFns } from "./JournalHandOverView.vue?vue&type=template&id=1530c881"
import script from "./JournalHandOverView.vue?vue&type=script&lang=js"
export * from "./JournalHandOverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports